import { datadogRum } from '@datadog/browser-rum';

const ErrorHandler = {
  track,
};

/**
 * Track error
 * @param    {Error}    [error]        Error
 */
function track(errorMessage, metaData = {}) {
  // This might be called before rumInit is called at the application level
  // or if the page is initialised without metadata.
  try {
    datadogRum.addError(errorMessage, metaData);

    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error(errorMessage, metaData);
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log('Datadog not initialised');
      // eslint-disable-next-line no-console
      console.error(errorMessage, metaData);
    }
  }
}

export default ErrorHandler;
